(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tl-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const enhance = (scope) => {
      if (preference.matches || !('IntersectionObserver' in window)) return;
      const images = scope.querySelectorAll('[data-tl-motion]:not([data-tl-observed])');
      if (!images.length) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('tl-in-view');
          observer.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px 40px 0px' });
      images.forEach((image) => {
        image.dataset.tlObserved = 'true';
        image.classList.add('tl-motion-ready');
        observer.observe(image);
      });
    };
    enhance(document);
    document.addEventListener('shopify:section:load', (event) => enhance(event.target));
    preference.addEventListener('change', () => {
      if (preference.matches) document.querySelectorAll('.tl-motion-ready').forEach((item) => item.classList.add('tl-in-view'));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = event.target.closest('[data-tl-menu][open]');
      if (!openMenu) return;
      openMenu.open = false;
      openMenu.querySelector('summary').focus();
    });
    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-tl-menu][open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tl-page-compositions"] && !Shopify.designMode) return;
  try {
    (() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let cleanup = () => {};
    const mount = () => {
      cleanup();
      const abort = new AbortController();
      const { signal } = abort;
      const toc = document.querySelector('.tl-route-taillai-guide .tl-toc');
      const links = toc ? [...toc.querySelectorAll('a[href^="#"]')] : [];
      const sections = links.map(link => document.getElementById(link.hash.slice(1)));
      const stages = [...document.querySelectorAll('.tl-route-delivery-and-warranty .tl-delivery__timeline li')];
      const progress = toc ? document.createElement('div') : null;
      if (progress) { progress.className = 'tl-reading-progress'; progress.setAttribute('aria-hidden','true'); document.body.append(progress); }
      let queued = false;
      const update = () => {
        queued = false;
        if (progress) {
          const first = sections.find(Boolean), last = sections.filter(Boolean).at(-1);
          if (first && last) {
            const start = first.getBoundingClientRect().top - 160;
            const end = last.getBoundingClientRect().bottom - window.innerHeight * .7;
            const fraction = Math.max(0,Math.min(1,-start / Math.max(1,end-start)));
            progress.style.setProperty('--reading-progress',fraction);
          }
          let active = 0;
          sections.forEach((section,index) => { if (section && section.getBoundingClientRect().top < 240) active = index; });
          links.forEach((link,index) => { if (index === active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); });
        }
        stages.forEach((stage,index) => {
          const rect = stage.getBoundingClientRect();
          const visible = rect.top < window.innerHeight * .8 && rect.bottom > 130;
          stage.style.transitionDelay = preference.matches ? '0ms' : `${index * 75}ms`;
          stage.classList.toggle('is-current', visible);
        });
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('resize',schedule,{passive:true,signal});
      preference.addEventListener('change',update,{signal});
      update();
      cleanup = () => { abort.abort(); progress?.remove(); };
    };
    mount();
    document.addEventListener('shopify:section:load',mount);
    document.addEventListener('shopify:section:unload',mount);
  })();
  } catch(e) { console.error(e); }
})();

})();
